import React from 'react';
import { Box, Container, Typography, Grid, Card, CardMedia, CardContent, useTheme } from '@mui/material';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import emmettImg from '../emmett.jpeg';
import brendanImg from '../brendan.jpeg';
import jimmyImg from '../jimmy.jpeg';
import joeImg from '../joe.jpeg';

const Band = () => {
  const theme = useTheme();
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });

  // Band member data from your old site
  const members = [
    {
      name: 'Emmett Lally',
      role: 'Lead Vocals / Rhythm Guitar',
      bio: 'Lead singer bringing the raw energy.',
      image: emmettImg,
    },
    {
      name: 'Joe Dimitri',
      role: 'Drums',
      bio: 'The powerhouse drummer driving the beat.',
      image: joeImg,
    },
    {
      name: "Brendan O'Sullivan",
      role: 'Lead Guitar',
      bio: 'Lead guitarist bringing the signature sound.',
      image: brendanImg,
    },
    {
      name: 'Jimmy Krug',
      role: 'Bass Guitar',
      bio: 'Bassist laying down the grooves.',
      image: jimmyImg,
    },
  ];

  return (
    <Box
      id="band"
      ref={ref}
      sx={{
        minHeight: '100vh',
        py: 10,
        backgroundColor: '#121212',
      }}
    >
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <Typography
            variant="h2"
            sx={{
              textAlign: 'center',
              mb: 2,
              fontSize: { xs: '2.5rem', md: '4rem' },
              color: '#FFFFFF',
            }}
          >
            THE BAND
          </Typography>
          <Box
            sx={{
              width: '100px',
              height: '4px',
              backgroundColor: theme.palette.primary.main,
              margin: '0 auto 4rem',
            }}
          />
        </motion.div>

        {/* Band Story
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <Box sx={{ mb: 8, textAlign: 'center', maxWidth: '900px', margin: '0 auto 6rem' }}>
            <Typography sx={{ color: theme.palette.primary.main, fontSize: '1.5rem', lineHeight: 1.8, fontWeight: 600 }}>
              The hottest indie/rock band on Long Island
            </Typography>
          </Box>
        </motion.div> */}

        {/* Band Members */}
        <Grid container spacing={4}>
          {members.map((member, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                animate={inView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.8, delay: 0.4 + index * 0.1 }}
              >
                <Card
                  sx={{
                    backgroundColor: '#1a1a1a',
                    border: '2px solid transparent',
                    '&:hover': {
                      borderColor: theme.palette.primary.light,
                      transform: 'translateY(-10px)',
                    },
                    transition: 'all 0.3s',
                  }}
                >
                  <CardMedia
                    component="img"
                    image={member.image}
                    alt={member.name}
                    sx={{
                      height: 350,
                      objectFit: 'cover',
                      objectPosition: 'center top',
                    }}
                  />
                  <CardContent sx={{ textAlign: 'center' }}>
                    <Typography variant="h6" sx={{ color: '#FFFFFF', fontWeight: 'bold', mb: 1 }}>
                      {member.name}
                    </Typography>
                    <Typography sx={{ color: theme.palette.primary.main, mb: 2, fontWeight: 600 }}>
                      {member.role}
                    </Typography>
                    <Typography sx={{ color: '#AAA', fontSize: '0.95rem' }}>
                      {member.bio}
                    </Typography>
                  </CardContent>
                </Card>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Band;
